export const getReviewRequests = (state = [], action) => {
    switch(action.type){
        case 'GET_REVIEW_REQUESTS':
            return{
                ...state,
                review_requests: action.payload.data,
                loading: false
            }
        case 'LOADING_REVIEW_REQUESTS':
            return{
                ...state,
                loading: true
            }
        case 'CLEAR_REVIEW_REQUESTS_TABLE':
            return{
                ...state,
                review_requests: undefined,
                loading: false
            }
        default:
            return{
                ...state
            }
    }
}
export const getTemplates = (state = [], action) => {
    switch(action.type){
        case 'GET_TEMPLATES':
            return{
                ...state,
                templates: action.payload
            }
        default: 
            return{
                ...state
            }
    }
}
export const checkLocationNumber = (state = "", action) => {
    switch(action.type){
        case 'CHECK_LOCATION_NUMBER':
            return{
                ...state,
                number: action.payload,
            }
        case 'SET_LOCATION_NUMBER':
            return{
                ...state,
                number: action.payload
            }
        case 'CLEAR_LOCATION_NUMBER':
            return{
                ...state,
                number: undefined
            }
        default: 
            return{
                ...state
            }
    }
}